
import { Vue, Component, Prop } from 'vue-property-decorator';
import debounce from 'lodash/debounce';

@Component<SeeMore>({})
export default class SeeMore extends Vue {
	@Prop({ type: String, required: true }) private content!: string;

	private seeMore: boolean = true;
	private isOverflowing: boolean = false;
	private debouncedCheckOverflow!: ReturnType<typeof debounce>;

	$refs!: {
		paragraph: HTMLParagraphElement;
	};

	/**
	 * Set up a "debounced checkOverflow" so that each instance of SeeMore has its own debounce logic
	 * instead of a shared one that would happen with the Debounce decorator.
	 *
	 * @return {void}
	 */
	private mounted(): void {
		this.debouncedCheckOverflow = debounce(this.checkOverflow, 100);
		this.$nextTick(() => this.checkOverflow());
		window.addEventListener('resize', this.debouncedCheckOverflow);
	}

	private beforeDestroy(): void {
		this.debouncedCheckOverflow.cancel();
		window.removeEventListener('resize', this.debouncedCheckOverflow);
	}

	/**
	 * Ensures the element is clamped, then compares scrollHeight vs clientHeight
	 * to determine if the content exceeds the 5-line clamp and needs a "See more" toggle.
	 *
	 * @return {void}
	 */
	private checkOverflow(): void {
		const el = this.$refs.paragraph;
		if (!el) {
			return;
		}

		const wasClamped = this.seeMore;

		if (!wasClamped) {
			el.classList.add('clamped');
		}

		this.isOverflowing = el.scrollHeight > el.clientHeight;

		if (!wasClamped) {
			el.classList.remove('clamped');
		}
	}

}
